module.exports = "/_next/static/images/hero-image-mobile-af75a8ea885524c7addfdc969355d208.jpg";